module.exports = __webpack_public_path__ + "img/katarina_karta.f112bf2e.png";